import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import { transactionsUtils, transactionsTypes } from 'companion-app-components/flux/transactions';

import QTip from 'components/QuickenControls/QTip';
import TagsField from 'components/QuickenControls/TagsField';
import QTypography from 'components/MUIWrappers/QTypography';

import { makeTagsString } from 'data/transactions/searchFilter';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface TagFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  field: string;
  enableAutoFocus: boolean;
  showSplitWindow: boolean;
  staticValue: string | React.JSX.Element;
  wrapClass: string; 
  editClass: string; 
  hoverClass: string;
  wrapText?: string;
  tagsAsHashes: any;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const TagField: FC<TagFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  SHOW_ALL,
  fieldActive,
  txn,
  field,
  enableAutoFocus,
  showSplitWindow,
  staticValue,
  wrapClass, 
  editClass, 
  hoverClass,
  wrapText,
  tagsAsHashes,
  focusField,
}) => {
  const { classes, theme } = useStyles();

  const renderTags = () => {
    const tagStatic = makeTagsString(txn.tags, tagsAsHashes);
    const isSplit = transactionsUtils.isSplitTxn(txn);

    let tagFrag;
    if (!showSplitWindow && fieldActive && !isSplit) {
      tagFrag = (
        <TagsField
          // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'
          disableUnderline={theme.mixins?.register.noUnderline}
          value={txn.tags}
          onChange={(e) => callbacks.handleChange?.(e, 'tags')}
          fieldId="tags"
          autoFocus={enableAutoFocus}
          inputRef={
            (input) => {
              focusField.current = input; // eslint-disable-line
            }
          }
        />
      );
    } else if (isSplit || showSplitWindow) {
      tagFrag =
        <QTypography
          clickable
          thinFont
          className={classes.regItemCore}
        >
        </QTypography>;
    } else {
      tagFrag =
        // @ts-expect-error: missing props
        <QTip
          wrapOnly
          title={wrapText ? null : tagStatic}
          wrapId={`${txn.id}-${field}`}
        >
          <QTypography
            clickable={!forceStatic ? 'true' : null}
            thinFont
            className={classes.regItemCore}
          >
            {tagStatic || staticValue}
          </QTypography>
        </QTip>;
    }
    return tagFrag;
  };

  return (
    <RegListItem
      {...attributes}
      className={classNames(classes.regItem, 'flex2', fieldActive ? 'wraptext' : wrapClass, editClass, hoverClass)}
    >
      {SHOW_ALL && renderTags()}
    </RegListItem>
  );
};

export default TagField;
